import { render, staticRenderFns } from "./BuyerReceiving.vue?vue&type=template&id=29701681&"
import script from "./BuyerReceiving.vue?vue&type=script&lang=js&"
export * from "./BuyerReceiving.vue?vue&type=script&lang=js&"
import style0 from "./BuyerReceiving.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports